import { FetchCustomFieldsParams } from 'api/customFields';
import { accountQueryKeys } from 'queries/account-query-keys';

const customFieldQueryKeys = {
    customFields: (accountId: number) => [...accountQueryKeys.current(accountId), 'custom-fields'],
    customFieldById: (accountId: number, customFieldId: number) => [
        ...customFieldQueryKeys.customFields(accountId),
        customFieldId,
    ],
    customFieldsWithFilters: (accountId: number, params: FetchCustomFieldsParams) => [
        ...customFieldQueryKeys.customFields(accountId),
        params,
    ],
};

export { customFieldQueryKeys };
